export abstract class Base
{
	protected _mtmAuto=null;
	protected _cStore=[];
	protected _role: any;
	protected _syncId=null;
	protected _isTerm=null;
	protected _connectTime=null;
	protected _parentObj=null;
	protected _txId=0;
	
	public setAuto(mtmAuto)
	{
		this._mtmAuto	= mtmAuto;
		return this;
	}
	public getAuto()
	{
		return this._mtmAuto;
	}
	public getSyncId()
	{
		return this._syncId;
	}
	public getConnectTime()
	{
		return this._connectTime;
	}
	public getTerminated()
	{
		return this._isTerm;
	}
	public getParent()
	{
		return this._parentObj;
	}
	public getRole()
	{
		return this._role;
	}
	public getTxId()
	{
		return this._txId;
	}
	public tickTx()
	{
		this._txId++;
		return this;
	}
	public getMessage(type, data=null)
	{
		var msgObj			= {};
		msgObj["service"]	= "MTM-WS-SYNC";
		msgObj["type"]		= type;
		msgObj["txId"]		= this.getTxId();
		msgObj["srcSync"]	= this.getParent().getGuid();
		msgObj["dstSync"]	= this.getSyncId();
		msgObj["data"]		= data;
		return msgObj;
	}
}